
import { defineComponent } from 'vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'

export default defineComponent({
    name: 'qbe-filter-parameters',
    components: { Column, DataTable },
    props: { visible: { type: Boolean }, propParameters: { type: Array } },
    emits: ['save', 'close', 'parametersUpdated'],
    data() {
        return {
            parameters: [] as any[]
        }
    },
    watch: {
        propParameters() {
            this.loadParameters()
        }
    },
    created() {
        this.loadParameters()
    },
    methods: {
        loadParameters() {
            this.parameters = []
            this.propParameters?.forEach((parameter: any) => {
                parameter.value = parameter.value ?? parameter.defaultValue
                this.parameters.push(parameter)
            })
        },
        onCellEditComplete(event: any) {
            this.parameters[event.index] = event.newData
            this.$emit('parametersUpdated', this.parameters)
        }
    }
})
